import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ReactComponent as StarIcon } from 'icons/star.svg';

import s from './Ratings.module.css';

const Star = ({ defaultValue, value, setShowRating, onChange, className }) => (
  <button
    className={cn(s.star, className)}
    onClick={e => {
      // form workaround
      e.preventDefault();
      onChange(value);
    }}
    onMouseEnter={() => setShowRating(value)}
    onMouseLeave={() => setShowRating(defaultValue)}
  >
    <StarIcon />
  </button>
);

const Ratings = ({ value: defaultValue, onChange, max }) => {
  const [showRaing, setShowRating] = useState(defaultValue);

  const values = useMemo(() => {
    const result = [];
    for (let i = 1; i <= max; i += 1) {
      result.push(i);
    }

    return result;
  }, [max]);

  return (
    <div className={cn(s.root, { [s.notTouchable]: !onChange })}>
      {values.map(value => (
        <Star
          onChange={onChange ? onChange : () => {}}
          className={cn({ [s.filled]: value <= showRaing })}
          setShowRating={setShowRating}
          key={value}
          value={value}
          defaultValue={defaultValue}
        />
      ))}
    </div>
  );
};

Ratings.defaultProps = {
  value: 0,
  max: 5,
};

Ratings.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

export default Ratings;
